import { Component, OnInit } from '@angular/core';
import { TranslateService } from '../i18n';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'simple-layout.component.html'
})
export class SimpleLayoutComponent implements OnInit {
  public status  : { isopen: boolean } = { isopen: false };
  public language: { lang: string, url: string };

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    const lang = localStorage.getItem('language') || 'EN';
    const url = lang === 'ES' ? 'assets/img/flags/Mexico.png' : 'assets/img/flags/USA.png';

    this.setLang(lang, url);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  setLang(lang: string, url: string) {
    this.language = { lang, url };
    localStorage.setItem('language', lang);
    this.translate.use(lang);
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/layouts/simple-layout.component.ts